namespace Areas.Finance.Research {
    "use strict";



    export function removeResearch() {

        const glGrid = $("#ResearchGrid").dxDataGrid("instance");


        const selectedRows = glGrid.getSelectedRowsData();

        if (selectedRows.length) {

            var selectedRowIds = glGrid.getSelectedRowKeys().join(',');
            var url = "/Finance/Research/RemoveFromResearch/?ids=" + selectedRowIds;

            sendRequest(url, "", "PUT", () => { $('#ResearchGrid').dxDataGrid("instance").refresh(); });

        }

        return;
    }





}

